
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0a8.97 8.97 0 016.142 2.42l-2.427 2.427a5.572 5.572 0 100 8.306l2.427 2.427A8.97 8.97 0 019 18 9 9 0 119 0z"}}),_c('path',{attrs:{"d":"M17.176 12.767A8.967 8.967 0 0018 9.001a8.964 8.964 0 00-.824-3.767L13.41 9z"}}),_c('defs',{attrs:{"id":"defs11"}},[_c('linearGradient',{attrs:{"id":"paint0_linear_2863_117195","x1":"128.58","x2":"170.53","y1":"57.04","y2":"58.2","gradientTransform":"matrix(.4317 0 0 .43168 -4.852 -4.852)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"id":"stop6","stop-color":"#3FD473"}}),_c('stop',{attrs:{"id":"stop8","offset":"1","stop-color":"#3CD39D"}})])])])
          )
        }
      }
    